<c-container class="mt-5 mb-5">
  @if (uiState === UIStateEnum.ShowData) {
    <div>
      <div class="flex-row justify-space-between align-center mb-3">
        <button mat-raised-button
                data-testid="add-new-frequently-asked-question"
                color="primary"
                (click)="onAddFaqClick()"
                matTooltip="add new FAQ"
                matTooltipShowDelay="500"> Add
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>

      <ag-grid-angular
        class="ag-theme-quartz"
        data-testid="faqs-table"
        rowClass="faq-row"
        [tooltipShowDelay]=0
        [autoSizeStrategy]="autoSizeStrategy"
        [domLayout]="'autoHeight'"
        [rowHeight]="50"
        [defaultColDef]="defaultColDef"
        overlayNoRowsTemplate="<span>No FAQs</span>"
        (gridReady)="onFAQGridReady($event)"
        [rowData]="selectFaqs$ | async"
        [columnDefs]="faqDefs">
      </ag-grid-angular>
    </div>
  } @else if (uiState === UIStateEnum.ShowLoading) {
    <mat-spinner class="center-margin"></mat-spinner>
  }
</c-container>
